export default __webpack_public_path__ + "static/media/img-0487-andorra-full-face.35f05d88.png";